export default __webpack_public_path__ + "static/header-bg-1ea1443bb44eb471ee5f0562e88c76f6.webp";